import consolv from 'lib/consolv';

const defaultConfig = {
	magnitePrebid: {
		enabled: false,
		failsafeTimeout: 2000,
		alias: [
			{
				match: 'dfp_leaderboard',
				pattern: 'dfp_leaderboard|dfp_top_banner|ad_page_top',
			},
		],
	},
};

function generateFirstPartyData(meta) {
	const data = {
		inventory: {
			topic: [],
		},
	};

	if (meta.page.topic) data.inventory.topic.push(meta.page.topic);
	return data;
}

/**
 * Creates the prebid request and callback that is called before loading slots
 * @param {MCPInstance} MCP
 * @param {Object} config
 */
const setupRequestBids = (MCP, oldConfig) => (event, { slots, addAsyncEvent, immediatelyLoad }) => {
	// Don't continue if the slot is lazy loaded
	if (event === 'beforeAppendSlot' && !immediatelyLoad) return;

	const config = MCP.Configurator.getConfiguration({ defaults: defaultConfig }).magnitePrebid;

	if (config.enabled !== true) return;

	const asyncEvent = new Promise((resolve) => {
		const { pbjs } = window;

		const slotMap = Array.from(slots.values())
			.filter(slot =>
				slot.meta.allowPrebidBidding !== false &&
				slot.meta.blockHeaderBidding !== true);

		if (!slotMap.length) {
			resolve();
			return;
		}

		const gptSlotObjects = slotMap.map(slot => slot.DFPSlot);

		const failsafeTimerRef = window.setTimeout(() => {
			const { failsafeTimeout } = config;
			consolv.log(`MCP: Magnite Prebid failsafe timeout exceeded at ${failsafeTimeout} seconds`);
			resolve();
		}, config.failsafeTimeout);

		/* eslint-disable-next-line prefer-arrow-callback */
		pbjs.que.push(function requestBids() {
			pbjs.rp.requestBids({
				callback: () => {
					window.clearTimeout(failsafeTimerRef);
					consolv.log('MCP: Magnite Prebid resolved');
					resolve();
				},
				gptSlotObjects,
				data: generateFirstPartyData(MCP.Configurator.meta),
			});
		});
	});

	addAsyncEvent(asyncEvent);
};

/**
 * Generates the configuration and sets up event listeners for slot loads
 */
export default function MagnitePrebidAdapter(MCP) {
	if (!window.pbjs || !window.pbjs.que) {
		window.pbjs = { ...window.pbjs, que: [] };
	}

	MCP.loaded.then(() => {
		const config = MCP.Configurator
			.getConfiguration({ defaults: defaultConfig }).magnitePrebid;

		if (!config.enabled) return;

		if (Array.isArray(config.alias)) {
			const updateDivPatterns = () => {
				const { adUnitPatterns } = window.pbjs.rp;

				if (!Array.isArray(config.alias) || config.alias.length === 0) return;

				if (!adUnitPatterns) return;
				adUnitPatterns.forEach((item, i) => {
					if (!item.aupname) return;

					const match = config.alias.find((entry) =>
						new RegExp(entry.match).exec(item.aupname));

					if (match?.pattern) {
						adUnitPatterns[i].divPattern = new RegExp(match.pattern);
					}
				});
			};

			window.pbjs.que.push(updateDivPatterns);
		}

		const requestBids = setupRequestBids(MCP, config);

		MCP.addEventListener('beforeLoadSlots',
			(...params) => requestBids('beforeLoadSlots', ...params));
		MCP.addEventListener('beforeAppendSlot',
			(...params) => requestBids('beforeAppendSlot', ...params));
		MCP.addEventListener('beforeRefreshSlots',
			(...params) => requestBids('beforeRefreshSlots', ...params));
	});
}
